export default __webpack_public_path__ + "f6611d6d.woff2";